export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function getString(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

export function hasProp<K extends string>(obj: unknown, key: K): obj is { [P in K]: unknown } {
  if (obj !== null && typeof obj === 'object') {
    return Object.hasOwn(obj, key)
  }
  return false
}


